/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { reportOverviewCompanyInfoDtoSchema } from "./reportOverviewCompanyInfoDtoSchema.ts";
import { reportOverviewLinksDtoSchema } from "./reportOverviewLinksDtoSchema.ts";
import { reportOverviewPipelineDtoSchema } from "./reportOverviewPipelineDtoSchema.ts";
import { reportOverviewThesisDtoSchema } from "./reportOverviewThesisDtoSchema.ts";
import { z } from "zod/v4";

export const reportOverviewDtoSchema = z.object({
  startupName: z.optional(z.string()),
  oneLiner: z.optional(z.string()),
  createdAt: z.optional(z.iso.datetime()),
  ratingScore: z.optional(z.int()),
  ratingLabel: z.optional(z.string()),
  companyDescription: z.optional(z.string()),
  companyPurpose: z.optional(z.string()),
  get pipeline() {
    return reportOverviewPipelineDtoSchema.optional();
  },
  get links() {
    return reportOverviewLinksDtoSchema.optional();
  },
  get thesis() {
    return reportOverviewThesisDtoSchema.optional();
  },
  get companyInfo() {
    return reportOverviewCompanyInfoDtoSchema.optional();
  },
});
